/**
 * Mapping produits imeteo → variables WMS + transforms.
 *
 * Chaque produit retourne :
 *   {
 *     variables:  string[]   — codes WMS à récupérer
 *     transforms: object[]   — transforms à appliquer (voir transforms.js)
 *     accumVars:  string[]   — variables accumulées depuis le début de la prévision
 *                              (nécessite la valeur au pas précédant la transition)
 *   }
 */

import { IMETEO_UV } from './transforms.js';

const PRODUCTS = {
  temp: {
    variables:  ['TT', 'ES'],
    transforms: [],
    accumVars:  [],
  },
  sous_sol: {
    variables:  ['TT', 'ES', 'P0'],
    transforms: [],
    accumVars:  [],
  },
  vents: {
    variables:  ['WSPD', 'WD', 'WGE'],
    transforms: [IMETEO_UV],
    accumVars:  [],
  },
  roses: {
    variables:  ['WSPD', 'WD', 'WGE', 'PR'],
    transforms: [IMETEO_UV],
    accumVars:  ['PR'],
  },
  precip: {
    variables:  ['PR'],
    transforms: [],
    accumVars:  ['PR'],
  },
  precip_type: {
    variables:  ['SN', 'RN', 'FR', 'PR'],
    transforms: [],
    accumVars:  ['SN', 'RN', 'FR', 'PR'],
  },
  nuages: {
    variables:  ['NT'],
    transforms: [],
    accumVars:  [],
  },
  solaire: {
    variables:  ['N4'],
    transforms: [],
    accumVars:  ['N4'],
  },
};

/**
 * Retourne la configuration WMS pour un produit imeteo.
 *
 * @param {string} product — ex: 'temp', 'vents', 'precip'
 * @returns {{ variables: string[], transforms: object[], accumVars: string[] }}
 * @throws {Error} si le produit n'est pas supporté
 */
export function productConfig(product) {
  const config = PRODUCTS[product];
  if (!config) {
    throw new Error(`Produit inconnu : "${product}". Produits supportés : ${Object.keys(PRODUCTS).join(', ')}`);
  }
  return config;
}

/**
 * Liste des produits imeteo supportés par WMS.
 * @returns {string[]}
 */
export function supportedProducts() {
  return Object.keys(PRODUCTS);
}
